module.exports = __webpack_public_path__ + "static/media/marker.4e824ed2.svg";